import type { ComponentType } from 'react';
import { WorkerListPage } from './WorkerListPage';
import { WorkerRecordPage } from './WorkerRecordPage';
import { WorkerFormPage } from './WorkerFormPage';
import { TerminationDetailsPage } from './TerminationDetailsPage';
import { EmployeeProcessesPage } from './EmployeeProcessesPage';
import { PayRunsPage } from './PayRunsPage';
import { StpManagementPage } from './StpManagementPage';
import { GeneralLedgerOverviewPage } from './GeneralLedgerOverviewPage';
import { CostCentrePage } from './CostCentrePage';
import { ChartOfAccountsPage } from './ChartOfAccountsPage';
import { FormulasPage } from './FormulasPage';
import { FactorsPage } from './FactorsPage';
import { RulePage } from './RulePage';
import { ExportPage } from './ExportPage';
import { ReportingPage } from './ReportingPage';
import { OrganisationPage } from './OrganisationPage';
import { StpSetupPage } from './StpSetupPage';
import { ConfigurationPage } from './ConfigurationPage';
import { LeavePage } from './LeavePage';
import { MaintenanceSuperannuationPage } from './MaintenanceSuperannuationPage';
import { PayrollSuperannuationPage } from './PayrollSuperannuationPage';
import { UsersAccessPage } from './UsersAccessPage';
import { SecurityRolesPage } from './SecurityRolesPage';
import { ApprovalWorkflowsPage } from './ApprovalWorkflowsPage';
import { GeneralParametersPage } from './GeneralParametersPage';
import { IntegrationSettingsPage } from './IntegrationSettingsPage';
import { ImportTemplatesOpeningBalancesPage } from './ImportTemplatesOpeningBalancesPage';
import { PaymentSetupPage } from './PaymentSetupPage';
import { PayrollNotesPage } from './PayrollNotesPage';
import { AuditLogPage } from './AuditLogPage';
import { AlertsNotificationsPage } from './AlertsNotificationsPage';

/** Maps an item's absolute route path to its page component, so App routing stays data-driven. */
export const pageRegistry: Record<string, ComponentType> = {
  '/workers/worker-list': WorkerListPage,
  '/workers/worker-record': WorkerRecordPage,
  '/workers/worker-form': WorkerFormPage,
  '/workers/termination-details': TerminationDetailsPage,
  '/workers/employee-processes': EmployeeProcessesPage,
  '/payroll/pay-runs': PayRunsPage,
  '/payroll/stp-management': StpManagementPage,
  '/payroll/superannuation': PayrollSuperannuationPage,
  '/general-ledger/overview': GeneralLedgerOverviewPage,
  '/general-ledger/cost-centre': CostCentrePage,
  '/general-ledger/chart-of-accounts': ChartOfAccountsPage,
  '/general-ledger/formulas': FormulasPage,
  '/general-ledger/factors': FactorsPage,
  '/general-ledger/rule': RulePage,
  '/general-ledger/export': ExportPage,
  '/general-ledger/reporting': ReportingPage,
  '/maintenance/organisations': OrganisationPage,
  '/maintenance/stp-setup': StpSetupPage,
  '/maintenance/configuration': ConfigurationPage,
  '/maintenance/leave': LeavePage,
  '/maintenance/superannuation': MaintenanceSuperannuationPage,
  '/administration/users-and-access': UsersAccessPage,
  '/administration/security-roles': SecurityRolesPage,
  '/administration/approval-workflows': ApprovalWorkflowsPage,
  '/administration/general-parameters': GeneralParametersPage,
  '/administration/integration-settings': IntegrationSettingsPage,
  '/administration/import-templates-and-opening-balances': ImportTemplatesOpeningBalancesPage,
  '/administration/payment-setup': PaymentSetupPage,
  '/administration/payroll-notes': PayrollNotesPage,
  '/administration/audit-log': AuditLogPage,
  '/administration/alerts-and-notifications': AlertsNotificationsPage,
};
